import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Simple shims for WeakMap and Map classes.
 * This implementation is not meant to be used outside of IntersectionObserver modules
 * because it covers only limited range of use cases.
 */
var hasNativeCollections = typeof window.WeakMap === 'function' && typeof window.Map === 'function';

var WeakMap = function () {
  if (hasNativeCollections) {
    return window.WeakMap;
  }
  /**
   *
   * @param {Array<Array>} arr
   * @param {Object} key
   * @returns {Number}
   */


  function getIndex(arr, key) {
    var result = -1;
    arr.some(function (entry, index) {
      var matches = entry[0] === key;

      if (matches) {
        result = index;
      }

      return matches;
    });
    return result;
  }

  return /*#__PURE__*/function () {
    function _class() {
      _classCallCheck(this, _class);

      this.__entries__ = [];
    }
    /**
     *
     * @param {Object} key
     * @returns {*}
     */


    _createClass(_class, [{
      key: "get",
      value: function get(key) {
        var index = getIndex(this.__entries__, key);
        return this.__entries__[index][1];
      }
      /**
       *
       * @param {Object} key
       * @param {*} value
       */

    }, {
      key: "set",
      value: function set(key, value) {
        var index = getIndex(this.__entries__, key);

        if (~index) {
          this.__entries__[index][1] = value;
        } else {
          this.__entries__.push([key, value]);
        }
      }
      /**
       *
       * @param {Object} key
       */

    }, {
      key: "delete",
      value: function _delete(key) {
        var entries = this.__entries__,
            index = getIndex(entries, key);

        if (~index) {
          entries.splice(index, 1);
        }
      }
      /**
       *
       * @param {Object} key
       * @returns {Boolean}
       */

    }, {
      key: "has",
      value: function has(key) {
        return !!~getIndex(this.__entries__, key);
      }
    }]);

    return _class;
  }();
}();

var Map = function () {
  if (hasNativeCollections) {
    return window.Map;
  }

  return /*#__PURE__*/function (_WeakMap) {
    _inherits(_class2, _WeakMap);

    var _super = _createSuper(_class2);

    function _class2() {
      _classCallCheck(this, _class2);

      return _super.apply(this, arguments);
    }

    _createClass(_class2, [{
      key: "size",
      get:
      /**
       *
       * @returns {Number}
       */
      function get() {
        return this.__entries__.length;
      }
    }, {
      key: "clear",
      value: function clear() {
        this.__entries__.splice(0, this.__entries__.length);
      }
      /**
       *
       * @returns {Array<Array>}
       */

    }, {
      key: "entries",
      value: function entries() {
        return this.__entries__.slice();
      }
      /**
       *
       * @returns {Array}
       */

    }, {
      key: "keys",
      value: function keys() {
        return this.__entries__.map(function (entry) {
          return entry[0];
        });
      }
      /**
       *
       * @returns {Array}
       */

    }, {
      key: "values",
      value: function values() {
        return this.__entries__.map(function (entry) {
          return entry[1];
        });
      }
      /**
       *
       * @param {Function} callback
       * @param {Object} [ctx = null]
       */

    }, {
      key: "forEach",
      value: function forEach(callback) {
        var ctx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        var _iterator = _createForOfIteratorHelper(this.__entries__),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var entry = _step.value;
            callback.call(ctx, entry[1], entry[0]);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }]);

    return _class2;
  }(WeakMap);
}();

export { Map, WeakMap };